import { useState } from 'react';
import { getApiBaseUrl } from '../../../../core/config/api';

interface UseCategoriesSpeConfigOpts {
  setError: (msg: string | null) => void;
  setSuccess: (msg: string | null) => void;
  loadAllData: () => Promise<void>;
}

/** Hook extrait de SystemConfiguration.tsx : catégories de spécialité. */
export function useCategoriesSpeConfig({
  setError,
  setSuccess,
  loadAllData,
}: UseCategoriesSpeConfigOpts) {
  const [newCategorieSpeNom, setNewCategorieSpeNom] = useState('');
  const [newCategorieSpeServiceId, setNewCategorieSpeServiceId] = useState<number>(0);
  const [creatingCategorieSpe, setCreatingCategorieSpe] = useState(false);

  const handleCreateCategorieSpe = async () => {
    const trimmed = newCategorieSpeNom.trim();
    if (!trimmed || newCategorieSpeServiceId <= 0) {
      setError('Indiquez un nom et un service.');
      return;
    }
    setCreatingCategorieSpe(true);
    setError(null);
    setSuccess(null);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError("Token d'authentification manquant");
        return;
      }
      const apiUrl = getApiBaseUrl();
      const response = await fetch(`${apiUrl}/api/config/categories-specialite`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ nom: trimmed, id_service: newCategorieSpeServiceId }),
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSuccess('Catégorie de spécialité créée.');
        setNewCategorieSpeNom('');
        setNewCategorieSpeServiceId(0);
        await loadAllData();
      } else {
        setError(data.error || 'Erreur lors de la création.');
      }
    } catch (err: any) {
      setError(err.message || 'Erreur lors de la création.');
    } finally {
      setCreatingCategorieSpe(false);
    }
  };

  return {
    newCategorieSpeNom,
    setNewCategorieSpeNom,
    newCategorieSpeServiceId,
    setNewCategorieSpeServiceId,
    creatingCategorieSpe,
    handleCreateCategorieSpe,
  };
}
